<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg6>
          <BusinessForm
            v-model="business"
            @submit="save"
            :backLink="{ name: 'businesses' }"
            title="Geschäft erstellen"
            submitText="Erstellen"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import Business from '@/models/business';

export default {
  name: 'NewBusiness',
  requireSuperuser: true,
  data() {
    return {
      business: new Business(),
    };
  },
  methods: {
    async save() {
      const business = await this.business.save();
      this.$showSnackbar({ text: 'Geschäft erfolgreich erstellt.', color: 'success' });
      this.$router.push(business.url);
    },
  },
};
</script>
